export default () => {
  if (global.ENABLE_MAINTENANCE_WINDOW === 'YES') {
    if (!global.MAINTENANCE_WINDOW_URL) {
      throw new Error('ENABLE_MAINTENANCE_WINDOW is \'YES\' but MAINTENANCE_WINDOW_URL is not specified');
    }
    return {
      isEnabled: true,
      url: global.MAINTENANCE_WINDOW_URL,
      isOfferStubEnabled: global.ENABLE_OFFERS_STUB_DURING_MAINTENANCE === 'YES',
    };
  } else return {
    isEnabled: false,
  };
};
